import React from "react"
import axios from "axios";
import { Switch, notification, Select } from 'antd';
import { setup as URI_SETUP } from "../../../../config/api";

const Option = Select.Option;
const uri_explore_csv = URI_SETUP+"data_source/csv/explore";
const uri_upload_schema = URI_SETUP+"data_source/csv/schema";

class ImportData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            col_sch_mleap_status            :   "hide",
            col_data_origin_status          :   "hide",
            col_sch_history_status          :   "hide",
            modal_new_sch_status            :   "hide",
            modal_save_sch_status            :  "hide",
            background_filter               :   "",
            dbfile                          :   "",
            dbtype                          :   "",
            dbtype_name                     :   "",
            sh_mleap_open                   :   "",
            file_name                       :   "CHOOSE FILE",
            lst_mleap_structure             :   [],
            lst_dbfile_structure            :   [],
            lst_importation_history         :   [],
            lst_catalog_origin              :   [],
            parsing_schema_active           :   [],
            schema_name                     :   "",
            catalog_origin                  :   null,             
            budget_period                   :   "day",
            registered_by                   :   "period",
            duplicated_ids                  :   false,
            record_by_night                 :   true,
            segment_by_market               :   false,
            revenue_with_taxes              :   false,
            budget_depth                    :   "segment",
            }
    }


    // ----------------------- Handlers -----------------------

    handleValueOperator(e){
        const target = e.target;
        const key = target.name;
        const value = target.value;
        let lst_mleap_structure = this.state.lst_mleap_structure
        lst_mleap_structure[key]['value_operator'] = value;
        //console.log(lst_mleap_structure);
        this.setState({
            lst_mleap_structure
        });
    }
    
    handleFileSelector(e) {
        if(e[0] != undefined){
            this.setState({ 
                dbfile      : e[0],
                file_name   : e[0].name
                })
        }
    }

    handleBudgetPeriod(e) {
        if(e != undefined){
            this.setState({ 
                budget_period  : e.currentTarget.value
                })
        }
    }

    handleReservationRegisteredBy(e) {
        if(e != undefined){
            this.setState({ 
                registered_by  : e.currentTarget.value
                })
        }
    }

    handleBudgetDepth(e) {
        if(e != undefined){
            this.setState({ 
                budget_depth  : e.currentTarget.value
                })
        }
    }

    handleDuplicatedIds(checked) { this.setState({duplicated_ids  : checked });}
    handleReservationByRoom(checked) {this.setState({record_by_night  : checked });}
    handleSegmentByMarket(checked) {this.setState({segment_by_market  : checked });}
    handleRevenueIncludeTaxes(checked) {this.setState({revenue_with_taxes  : checked });}

    handleSchemaTypeChange = (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        this.setState({ 
            dbtype      : event.target.value,
            dbtype_name : event.nativeEvent.target[index].text
            })
    }

    handleSchMagnumOpen(key){
        let item_opened = "";
        if(this.state.sh_mleap_open!=key){
            item_opened = key;
        }
        this.setState({ 
            sh_mleap_open   : item_opened
            }) 
    }

    handleSchemaNameChange = (e) => {
        this.setState({
            schema_name : e.target.value
        });
    }

    handleCatalogOrigin (value){
        let self = this;  
        console.log(value);
        self.setState({
            catalog_origin : value[(value.length-1)]
        });
    }

    // ----------------------- Functions -----------------------
    
    newSchema() {
        this.setState({ 
            modal_new_sch_status            : "",
            background_filter               : "blur",
            file_name                       :   "CHOOSE FILE",
            lst_mleap_structure             :   [],
            lst_dbfile_structure            :   [],
            dbfile                          :   "",
            dbtype                          :   [],
            col_sch_mleap_status            :   "hide",
            col_data_origin_status          :   "hide",
            col_sch_history_status          :   "hide"
            })
    }
    
    cancelNewSchema(e){
        e.preventDefault();
        let self = this;
        self.setState({ 
            modal_new_sch_status    : "hide",
            background_filter       : "",
            dbfile                  : "",
            file_name               : "CHOOSE FILE"
            })
    }

    cancelSchema(e){
        let self = this;
        self.setState({ 
            lst_mleap_structure           : [],
            lst_dbfile_structure          : [],
            col_data_origin_status        : "hide",
            col_sch_mleap_status          : "hide",
            col_sch_history_status        : "hide",
            schema_name                   : ""
            })
    }

    saveSchema() {
        this.setState({ 
            modal_save_sch_status         : "",
            background_filter             : "blur"
            })
    }

    cancelSaveSchema(){
        let self = this;
        self.setState({ 
            modal_save_sch_status   : "hide",
            background_filter       : ""
            })
    }

    onSubmitDefineSchema(e){
        let self = this;            
        e.preventDefault();

        if(this.state.dbfile!='' && self.state.dbtype!=''){

            let formData = new FormData();
            formData.append('api_token',localStorage.getItem("api_token"));
            formData.append('dbfile', self.state.dbfile);
            formData.append('dbtype', self.state.dbtype);
            /*
            const config = {
                onUploadProgress:function (progressEvent) {
                    const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                    //console.log("onUploadProgress", totalLength);
                    if (totalLength !== null) {
                        //console.log(Math.round( (progressEvent.loaded * 100) / totalLength ));
                    }
                }
            };
            */

            axios.post(uri_explore_csv, formData/*, config */).then(request => {
                        let catalog_origin=null;
                         if(request.data.catalog_origins.length>0){
                            catalog_origin=request.data.catalog_origins[0].name;
                         }
                        self.setState({ 
                            modal_new_sch_status    : "hide",
                            background_filter       : "",
                            col_sch_mleap_status    : "",
                            col_data_origin_status  : "",
                            col_sch_history_status  : "hide",
                            lst_mleap_structure     : request.data.magnum_schema,
                            lst_dbfile_structure    : request.data.uploaded_file,
                            lst_catalog_origin      : request.data.catalog_origins,
                            catalog_origin          : catalog_origin
                            })
                        
                    })  
            
        }
        
    }

    onDragStart = (ev, index) => {
        ev.dataTransfer.setData("index", index);
    }

    onDragOver = (ev) => {
        ev.preventDefault();
    }

    onDrop = (ev, key) => {
        let index = ev.dataTransfer.getData("index");
        let value=[];

        const lst_mleap_structure = this.state.lst_mleap_structure;
        const lst_dbfile_structure = this.state.lst_dbfile_structure;
        if(lst_mleap_structure[key].value_type==lst_dbfile_structure[index].value_type 
            || lst_mleap_structure[key].value_type=="Text"
            || lst_dbfile_structure[index].value_type ==''){
            /*    
            if(lst_mleap_structure[key].value!=""){
                lst_dbfile_structure[lst_mleap_structure[key].value].unassigned = true;
            }
            */
           if(lst_mleap_structure[key].value==undefined){
                lst_mleap_structure[key]['value']= new Array();
           }
    
            lst_mleap_structure[key]['value'].push(index);

            lst_dbfile_structure[index].unassigned = false;
            this.setState({
                lst_mleap_structure,
                lst_dbfile_structure
            });

        }

    }

    unassignValue (key,value) {
        const lst_dbfile_structure = this.state.lst_dbfile_structure;
        const lst_mleap_structure = this.state.lst_mleap_structure;
        lst_dbfile_structure[value].unassigned = true;
        let index = lst_mleap_structure[key].value.indexOf(value);
        lst_mleap_structure[key].value.splice(index,1);
        
        this.setState({
            lst_mleap_structure,
            lst_dbfile_structure
        });
     }

    onSubmitSchema(e){
        let self = this;            
        e.preventDefault();
        
        if(this.state.dbfile!='' && self.state.dbtype!=''){

            let formData = new FormData();
            formData.append('api_token',localStorage.getItem("api_token"));
            formData.append('name',this.state.schema_name);
            formData.append('catalog_origin',this.state.catalog_origin);
            formData.append('schema_property',this.props.app.state.hotel_selected);

            if(this.state.dbtype=="budget"){
                formData.append('dbtype',this.state.dbtype+"_"+this.state.budget_period);
            }else{
                formData.append('dbtype',this.state.dbtype);
            }   

            if(this.state.dbtype=="budgetbycols"){
                formData.append('budget_depth',this.state.budget_depth);
                formData.append('segment_by_market', this.state.segment_by_market);
            }

            if(this.state.dbtype=='reservations'){
                formData.append('registered_by',this.state.registered_by);
                formData.append('duplicated_ids', this.state.duplicated_ids);
                formData.append('revenue_with_taxes', this.state.revenue_with_taxes);
                formData.append('record_by_night', this.state.record_by_night);
                formData.append('segment_by_market', this.state.segment_by_market);
            }

            Object.keys(this.state.lst_mleap_structure).map((key, index) => {
                if(this.state.lst_mleap_structure[key].value!=undefined){
                    formData.append(key+'[name]', this.state.lst_mleap_structure[key].name);
                    formData.append(key+'[catalog]', this.state.lst_mleap_structure[key].catalog);
                    formData.append(key+'[value_type]', this.state.lst_mleap_structure[key].value_type);
                    if(this.state.lst_mleap_structure[key].value_operator!=undefined && this.state.lst_mleap_structure[key].value.length>1){
                        formData.append(key+'[value_operator]', this.state.lst_mleap_structure[key].value_operator);
                    }
                    Object.keys(this.state.lst_mleap_structure[key].value).map((key_position, index_position) => {
                        formData.append(key+'[position]'+'['+key_position+']', this.state.lst_mleap_structure[key].value[key_position]);
                    });
                }
            });
            axios.post(uri_upload_schema, formData)
                    .then(request => { 
                        if(request.data.result.type=='error'){
                            notification.open({
                                message: 'Unsuccessful',
                                description: request.data.result.message
                              });
                            self.setState({ 
                                modal_save_sch_status         : "hide",
                                background_filter             : "",
                                schema_name                   : ""
                            });
                        }else{
                            this.props.setActiveHotel(this.props.app.state.hotel_selected);
                            self.setState({ 
                                modal_save_sch_status         : "hide",
                                background_filter             : "",
                                lst_mleap_structure           : [],
                                lst_dbfile_structure          : [],
                                col_data_origin_status        : "hide",
                                col_sch_mleap_status          : "hide",
                                schema_name                   : "",
                                dbfile                        : "",
                                file_name                     : "CHOOSE FILE"
                                })  
                        }
                    })
                    .catch(error => {
                        notification.open({
                            message: 'Unsuccessful',
                            description: "Some information is missing please review the schema structure"
                          });
                        self.setState({ 
                            modal_save_sch_status         : "hide",
                            background_filter             : "",
                            schema_name                   : ""
                        });
                        
                        
                    })
            
        }
        
    }

    showSelectedSchema(parsing_schema_active){
        this.setState({
            parsing_schema_active : parsing_schema_active,
            col_sch_history_status : ""
        });
    }

    getParsingSchemaType(type){
        switch(type) {
            case "reservations":
                return "Reservations";
            case "room_stock":
                return "Availability";
            default:
                return "Budget";
          }

    }

    DuplicateFileValue(element){
        let lst_dbfile_structure = this.state.lst_dbfile_structure;
        let ele = Object.assign({}, element);
        ele['duplicated']=true;
        lst_dbfile_structure.push(ele);
        this.setState({  lst_dbfile_structure }); 
    }

    RemoveFileValue(key){
        const lst_dbfile_structure = this.state.lst_dbfile_structure;
        lst_dbfile_structure.splice(key,1);
        this.setState({
            lst_dbfile_structure
        });
    }


    // ----------------------- Renders -----------------------
    
    renderSelectParsingSchemas() {
        let self = this;
        return <ul>
                    {   
                        Object.keys(self.props.app.state.parsing_schema_list).map((key, index) => {
                            return (<li className="clickable" key={index} > 
                                <div>
                                    <div className="ellipsed">{self.props.app.state.parsing_schema_list[key].name}</div> 
                                    <i className="fa fa-angle-right clickable" onClick={self.showSelectedSchema.bind(self,self.props.app.state.parsing_schema_list[key])}></i>
                                </div>
                            </li>);
                        })
                    }
                </ul>   
    }

    renderFieldValue(key) {
        if (this.state.lst_mleap_structure[key].value!=undefined){ 
            return <ul className="alias-listing" 
                    onDragOver={(e)=>this.onDragOver(e)}
                    onDrop={(e)=>{this.onDrop(e, key)}}>
                        {this.state.lst_mleap_structure[key].value.length>1 &&
                            <li>
                                <select className="form-control" name={key} value={(this.state.lst_mleap_structure[key].value_operator!=undefined ? this.state.lst_mleap_structure[key].value_operator : '' )} onChange={e => this.handleValueOperator(e)}  >
                                    <option value="" disabled>Select value Operator</option>
                                    <option value="concat">Concatenate</option>
                                    <option value="first_found">First value found</option>
                                </select>  
                            </li>
                        }

                        {this.state.lst_mleap_structure[key].value.map((key_value) => { 
                             return <li key={key_value} >
                                        <div className="item-with-details">
                                            {this.state.lst_dbfile_structure[key_value].name}
                                            <br />
                                            <i className="fa fa-times-circle remove clickable" onClick={this.unassignValue.bind(this,key,key_value)} ></i>
                                            <span className="item-details">
                                                {this.state.lst_dbfile_structure[key_value].example}  
                                                <i> {this.state.lst_dbfile_structure[key_value].value_type}</i>
                                            </span>
                                        </div>
                                    </li> 
                        })}

                </ul>   

        }else{
            return <ul className="alias-listing" 
                        onDragOver={(e)=>this.onDragOver(e)}
                        onDrop={(e)=>{this.onDrop(e, key)}}>
                    </ul>   

        }
    }

    renderCatalogOrigins(){
        Object.keys(this.state.lst_catalog_origin).map((key, index) => {
            return <Option key={ this.state.lst_catalog_origin[key]._id }>{ this.state.lst_catalog_origin[key].name }</Option>
        })
    }

    renderMagnumStructure() {
        return  <ul className="list-scrollable">
                    <li className="list-header"><div className="label">{this.state.dbtype_name} </div></li>
                    <li className="radio-inlist">
                        <div className="form-row">
                            <div className="col col-md-5">
                                <label>Catalog Origin:</label>      
                            </div>
                            <div className="col col-md-7">
                                <Select
                                    mode="tags"
                                    placeholder="Select or create one"
                                    style={{ width: '100%' }}
                                    onChange={this.handleCatalogOrigin.bind(this)}
                                    size = {1}
                                    value = {this.state.catalog_origin}
                                >
                                    {this.renderCatalogOrigins()}
                                </Select>   
                            </div>
                        </div>
                    </li> 
                    {this.state.dbtype=="budget" &&
                        <li className="radio-inlist">
                            <p>Budget defined by:</p>
                            <div className="radio" >
                                <label><input type="radio" name="budget_period" value="day" onClick={this.handleBudgetPeriod.bind(this)}  defaultChecked={this.state.budget_period} />Day</label>
                            </div>
                            <div className="radio">
                                <label><input type="radio" name="budget_period" value="month" onClick={this.handleBudgetPeriod.bind(this)} defaultChecked={this.state.budget_period} />Month</label>
                            </div>
                            <div className="radio">
                                <label><input type="radio" name="budget_period" value="year" onClick={this.handleBudgetPeriod.bind(this)}  defaultChecked={this.state.budget_period} />Year</label>
                            </div>

                        </li>  }
                        {this.state.dbtype=="budgetbycols" &&
                        <li className="radio-inlist">
                            <div className="form-row">
                                <div className="col col-md-7">
                                    <label>Segment By Market:</label>      
                                </div>
                                <div className="col col-md-3">
                                    <Switch onChange={this.handleSegmentByMarket.bind(this)} checked={this.state.segment_by_market}  />   
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-7">
                                    <label>Budget Depth:</label>      
                                </div>
                                <div className="col col-md-5">
                                    <select className="form-control" name="registered_by" value={this.state.budget_depth} onChange={this.handleBudgetDepth.bind(this)}  >
                                        <option value="segment">Segment</option>
                                        <option value="agency" disabled>Agency</option>
                                    </select>    
                                </div>
                            </div>

                        </li>
                        }
                    {this.state.dbtype=="reservations" &&
                        <li className="radio-inlist">
                            <div className="form-row">
                                <div className="col col-md-7">
                                    <label>Reservations registered by:</label>      
                                </div>
                                <div className="col col-md-5">
                                    <select className="form-control" name="registered_by" value={this.state.registered_by} onChange={this.handleReservationRegisteredBy.bind(this)}  >
                                        <option value="period">Period</option>
                                        <option value="day">Day</option>
                                    </select>    
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-7">
                                    <label>Revenue include taxes:</label>      
                                </div>
                                <div className="col col-md-3">
                                    <Switch onChange={this.handleRevenueIncludeTaxes.bind(this)} checked={this.state.revenue_with_taxes}  />   
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-7">
                                    <label>Duplicated Reservation Id: </label>     
                                </div>
                                <div className="col col-md-3">
                                    <Switch onChange={this.handleDuplicatedIds.bind(this)} checked={this.state.duplicated_ids}  />   
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-7">
                                    <label>Record as Room night:</label>      
                                </div>
                                <div className="col col-md-3">
                                    <Switch onChange={this.handleReservationByRoom.bind(this)} checked={this.state.record_by_night}  />   
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-7">
                                    <label>Segment By Market:</label>      
                                </div>
                                <div className="col col-md-3">
                                    <Switch onChange={this.handleSegmentByMarket.bind(this)} checked={this.state.segment_by_market}  />   
                                </div>
                            </div>
                            
                            
                        </li>  }

                    {Object.keys(this.state.lst_mleap_structure).map((key, index) => {
                        return (<li key={key}
                                    className={"sub-list" + (this.state.sh_mleap_open==key? "" : " collapsed" ) + (this.state.lst_mleap_structure[key].required? " required" : "" ) }
                                >
                                    <div className="item-with-details">
                                        {this.state.lst_mleap_structure[key].name}
                                        
                                        <i  className={"clickable fa " + (this.state.sh_mleap_open==key? "fa-angle-up" : "fa-angle-down" )} 
                                            onClick={this.handleSchMagnumOpen.bind(this,key)} >
                                        </i>
                                        {(this.state.lst_mleap_structure[key].value!=undefined && Object.keys(this.state.lst_mleap_structure[key].value).length>0)  &&
                                            <span className= "float-right circle-note gray"> { Object.keys(this.state.lst_mleap_structure[key].value).length } </span>
                                        }
                                        <br />
                                        <span className="item-details">
                                            {this.state.lst_mleap_structure[key].example}  
                                            <i> {this.state.lst_mleap_structure[key].value_type}</i>
                                        </span>
                                        

                                    </div>
                                    {this.renderFieldValue(key) }
                                </li>);
                        }
                    )
                        
                    }
                </ul>   
    }
    
    renderFileStructure() {
        return  <ul>
                    <li className="sub-list" ><div>File Structure <i className="fa fa-angle-down"></i>  </div>
                        <ul>
                             {Object.keys(this.state.lst_dbfile_structure).map((key, index) => {
                                 if(this.state.lst_dbfile_structure[key].position!=undefined){
                                     if(this.state.lst_dbfile_structure[key].unassigned) {
                                        return (<li key={index} className={(this.state.lst_dbfile_structure[key].duplicated != undefined ? "duplicated" : "" ) + " clickable" } draggable="true" onDragStart = {(e) => this.onDragStart(e, this.state.lst_dbfile_structure[key].position)} >
                                                    <div className="item-with-details">
                                                        {this.state.lst_dbfile_structure[key].name}
                                                        <br />
                                                        <span className="item-details">
                                                            {this.state.lst_dbfile_structure[key].example}
                                                            { /* <i className="fa fa-remove remove clickable" onClick={this.RemoveFileValue.bind(this,key)} ></i> */ }   
                                                            <i className="fa fa-copy clickable" onClick={this.DuplicateFileValue.bind(this,this.state.lst_dbfile_structure[key])} ></i>
                                                            <i> {this.state.lst_dbfile_structure[key].value_type} &nbsp; </i>
                                                        </span>
                                                    </div>
                                                </li>);
                                        }
                                    }
                                })
                            }
                        </ul>
                    </li>
                        
                </ul>   
    }

    renderImportationHistory(){
            let self = this;
            return <ul>
                        {   
                            Object.keys(self.state.lst_importation_history).map((key, index) => {
                                return (<li className="clickable" key={index} > 
                                    <div>
                                    </div>
                                </li>);
                            })
                        }
                    </ul>   
        }
    

    renderNewSchema() {
        return <div className="box regular col-md-4 ">
                    <h3>DEFINE NEW SCHEMA  <i className="fa fa-times-circle" onClick={this.cancelNewSchema.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="schema_form" onSubmit={this.onSubmitDefineSchema.bind(this)}>
                            <div className="form-row form-modal">
                                <div className="col col-md-12"> 
                                    <select className="form-control " value={this.state.dbtype} name="db_type" onChange={this.handleSchemaTypeChange} required  >
                                        <option disabled value="">Schema type</option>
                                        <option value="reservations">Reservations</option>
                                        <option value="budget">Budget</option>
                                        <option value="budgetbycols">Budget by columns</option>
                                        <option value="room_stock">Availability</option>
                                    </select> 
                                </div> 
                            </div>
                            
                            <div className="form-row importing-csv">
                                <div className="col col-md-9">
                                    <button>{this.state.file_name} </button>
                                    <input type="file" name="dbfile" onChange={ (e) => this.handleFileSelector(e.target.files) } key={this.state.dbfile || '' } /> 
                                </div>
                            
                                <div className="col col-md-3">
                                    <select className="form-control " name="file_type" >
                                        <option disabled>FILE TYPE</option>
                                        <option value="csv">.csv</option>
                                    </select>   
                                </div>
                            </div>
                            
                            <div className="form-row modal-buttons">
                                <div className="col col-md-6">
                                    <button onClick={this.cancelNewSchema.bind(this)}>CANCEL</button>   
                                </div>
                                <div className="col col-md-6">
                                    <button type="submit" className="blue" >DEFINE</button> 
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>

    }

    renderSaveSchema() {
        return <div className="box regular col-md-4 ">
                    <h3>SAVE SCHEMA  <i className="fa fa-times-circle" onClick={this.cancelSaveSchema.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="schema_form" onSubmit={this.onSubmitSchema.bind(this)}>
                                <div className="form-row form-modal">
                                    <div className="col col-md-12"> 
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={this.state.schema_name} required  onChange={e => this.handleSchemaNameChange(e)} />          
                                </div> 
                            </div>
                            <div className="form-row modal-buttons">
                                <div className="col col-md-6">
                                    <button onClick={this.cancelSaveSchema.bind(this)}>CANCEL</button>   
                                </div>
                                <div className="col col-md-6">
                                    <button type="submit" className="blue" >SAVE</button> 
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>

    }

    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="top-form ">
                        <form id="catalog_item_form"  >
                            <div className="form-row">
                                <div className="col col-md-3">
                                    {this.props.renderSelectHotels()}
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="head-content "> 
                            <div className="icon col-md-2 px-2">
                                <h1>Setup</h1>
                                <h2>Data Import </h2>
                            </div>
                            <div className="col-md-8 px-2">    
                                
                                <div className="description">
                                    <p className="desc-no-icon"><strong>When setting up the data import configuration, </strong> <br/> it’s important that the words that your client database (or PMS) already uses EXACTLY match the words that you add to Magnum Leap in this step. It’s as if your client database is one puzzle piece and you’re making the puzzle piece that will fit perfectly with your database.</p>
                                </div>
                            </div>
                    </div>

                    <div className="col-md-12 no-padding"> 
                        <div className="box regular col-md-4">
                            <h3>SCHEMAS DEFINED</h3>
                            <div className="list-in-box">
                                { this.renderSelectParsingSchemas() }
                                <button className="blue" onClick={this.newSchema.bind(this)}>NEW</button>
                            </div>
                        </div>

                        <div className={"box regular col-md-8 " + this.state.col_sch_history_status}>
                            <h3>IMPORTATION SCHEMA DETAILS</h3>
                            <div className="importation-schema-details">
                                { this.state.parsing_schema_active!=undefined &&
                                    <ul>
                                        <li>Type: <span> {this.getParsingSchemaType(this.state.parsing_schema_active.type)} </span></li>
                                        { (this.state.parsing_schema_active.registered_by != undefined) && <li> Registered By: <span> { this.state.parsing_schema_active.registered_by }  </span> </li> }
                                        { (this.state.parsing_schema_active.duplicated_ids != undefined) && <li> Allow Duplicated IDs: <span>  <Switch disabled={this.state.disabled} checked={this.state.parsing_schema_active.duplicated_ids}  />   </span> </li> }
                                        { (this.state.parsing_schema_active.revenue_with_taxes != undefined) && <li> Revenue include Taxes: <span> <Switch disabled={this.state.disabled} checked={this.state.parsing_schema_active.revenue_with_taxes}  />   </span> </li> }
                                        <li>Created At: <span> { this.state.parsing_schema_active.created_at != undefined ? this.state.parsing_schema_active.created_at.split(' ')[0] : ''} </span></li>
                                    </ul>
                                }    
                            </div>
                            <div className="list-in-box">
                                <h4>Importation History</h4>
                                { /* this.renderImportationHistory() */ }
                            </div>
                        </div>
                            <div className={"box regular col-md-4 " + this.state.col_sch_mleap_status}>
                                <h3>MAGNUM LEAP EXPRESSIONS</h3>
                                <div className="list-in-box">
                                    {this.renderMagnumStructure()}
                                </div>
                                <div className="col-md-6 bottom-buttons">
                                    <button onClick={this.cancelSchema.bind(this)}>CANCEL</button>
                                </div>
                                <div className="col-md-6 bottom-buttons">
                                    <button className="blue" onClick={this.saveSchema.bind(this)}>SAVE</button> 
                                </div>
                            </div>
                            <div className={"box regular col-md-4 " + this.state.col_data_origin_status}>
                                <h3>DATA ORIGIN</h3>
                                <div className="list-in-box">
                                    {this.renderFileStructure()}
                                </div>
                            </div>
                        
                    </div>
                </div>

                <div className={"modal " + this.state.modal_new_sch_status}> 
                    {this.renderNewSchema()}
                </div>

                <div className={"modal " + this.state.modal_save_sch_status}> 
                    {this.renderSaveSchema()}
                </div>

            </section>
        )
    }

}

export default ImportData


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/ImportData.js